import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export enum EnabledModuleTabsRequestKey {
  People = 'ENABLED_TABS_PEOPLE',
  Rewarding = 'ENABLED_TABS_REWARDING',
  Performance = 'ENABLED_TABS_PERFORMANCE',
  Development = 'ENABLED_TABS_DEVELOPMENT',
  Planning = 'ENABLED_TABS_PLANNING',
}
export const GET_ENABLED_MODULE_TABS_SWR_KEY =
  'GET_ENABLED_MODULE_TABS_SWR_KEY';
export const getEnabledModuleTabs = (moduleKey: string) =>
  fetchFromOldApi(`/json/company/${moduleKey}/tabs`).then((r) => r.json());

export const useGetEnabledModuleTabs = (args: {
  moduleTabsRequestKey: EnabledModuleTabsRequestKey;
}): UseSWROutput<string[]> => {
  return useSWR(
    [GET_ENABLED_MODULE_TABS_SWR_KEY, args.moduleTabsRequestKey],
    ([_, moduleTabsKey]) => getEnabledModuleTabs(moduleTabsKey).then((r) => r),
  );
};
